<template>
  <div class="pitch__button-bar" :class="{'is--centered': centered}">
    <slot/>
  </div>
</template>

<script>

export default {
  name: 'ButtonBar',
  data: () => ({
  }),
  components: {
  },
  computed: {
  },
  mounted() {
  },
  props: {
    centered: {
      default: false,
      required: false
    }
  },
  methods: {
  }
};
</script>

<style lang="scss">
@import "../../scss/global/includes";
@import '../../scss/global/fonts.scss';


.pitch__button-bar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 5vh 0;
  &.is--centered {
    justify-content: center;
  }
    button {
      width: 100%;
    }

  @include breakpoint(tablet) {
    button, a {
      width: 100%!important;
    }
  }
}

</style>